import requests from '../requests'
import {
  BILLINGS_URL,
  SYSTEM_SETTINGS,
  ORGANIZATION_SETTINGS_URL,
} from '@/assets/variables/endpoints'

export const state = () => ({
  feature: { web: { menu: {}, page: {} } },
  billing_info: {
    billing_enabled: '',
    package_name: '',
    status: '',
    valid_until: '',
    payment_type: '',
  },
  status: false,
  isInitiated: false,
  isSuccessCallbackSSO: {
    status: false,
    message: '',
  },
  feature_flag_state: {
    self_topup: [],
    company_validation: [],
  },
  authToSend: '',
  time_to_refresh_token_sso: null,
  chatbot_subscription: {
    list: [],
    airene_resource_enabled: false,
    scorecard_chatbot_subscription: false,
    ai_summarization_enabled: false,
    ai_paraphrase_enabled: false,
  },
  chatbot_preferences: {
    list: [],
    global_sqs_report: false,
  },
  userManagement: {},
  agent_can_send_broadcast: false, // Store agent_can_send_broadcast setting
})

export const getters = {
  getFeatures(state) {
    return state.feature
  },
  getFeatureFlag(state) {
    return state.feature_flag_state
  },
  isInitiated(state) {
    return state.isInitiated
  },
  getIsSuccessCallbackSSO(state) {
    return state.isSuccessCallbackSSO
  },
  getBillingInfo(state) {
    return state.billing_info
  },
  getChatbotSubs(state) {
    return state.chatbot_subscription
  },
  getChatbotPreferences(state) {
    return state.chatbot_preferences
  },
  getAgentCanSendBroadcast(state) {
    return state.agent_can_send_broadcast
  },
}

export const actions = {
  getBillingInfoConfig({ commit }, params) {
    return new Promise((resolve, reject) => {
      requests.whatsapp
        .getService(
          `${BILLINGS_URL}/info`,
          {},
          { Authorization: this.$auth.getToken('hub') }
        )
        .subscribe(
          (res) => {
            commit('SET_BILLING_INFO', res.data)
            resolve(res.data)
          },
          (err) => {
            reject(err)
          }
        )
    })
  },
  getFeatureFlag({ commit }, params) {
    return new Promise((resolve, reject) => {
      requests.whatsapp
        .getService(
          `${SYSTEM_SETTINGS}`,
          {},
          { Authorization: this.$auth.getToken('hub') }
        )
        .subscribe(
          (res) => {
            commit('SET_FEATURE_FLAG_MENU', res.data[params])
            resolve(res.data[params])
          },
          (err) => {
            reject(err)
          }
        )
    })
  },
  getPicValidation({ commit }, params) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: this.$auth.getToken('hub'),
        },
      }
      this.$axios
        .get(`${ORGANIZATION_SETTINGS_URL}/validations`, config)
        .then(({ data: res }) => {
          resolve(res.data)
        })
    })
  },
  updatePicValidation({ commit }, params) {
    return new Promise((resolve, reject) => {
      const config = {
        headers: {
          Authorization: this.$auth.getToken('hub'),
        },
      }
      this.$axios
        .post(`${ORGANIZATION_SETTINGS_URL}/validations`, params, config)
        .then(({ data: res }) => {
          resolve(res.data)
        })
        .catch(function (error) {
          if (error.response) {
            reject(error.response.data)
          }
        })
    })
  },
}

export const mutations = {
  FEATURE(state, settings) {
    state.feature = settings
    state.status = true
  },
  UPDATE_FEATURE_FROM_SETTINGS(state, payload) {
    payload.menu.forEach((data) => {
      state.feature.menu = {
        ...state.feature.menu,
        ...data,
      }
    })
    payload.submenu.forEach((data) => {
      state.feature.submenu = {
        ...state.feature.submenu,
        ...data,
      }
    })
  },
  UPDATE_FIRST_INIT(state, payload) {
    state.isInitiated = payload
  },
  SET_SUCCESS_CALLBACK_SSO(state, payload) {
    state.isSuccessCallbackSSO = payload
  },
  SET_FEATURE_FLAG_MENU(state, payload) {
    if (state.feature_flag_state) {
      state.feature_flag_state[payload.key] = payload
    }
  },
  SET_BILLING_INFO(state, payload) {
    console.log('billing_info: ', payload)
    state.billing_info = payload
  },
  SET_NEW_TOKEN(state, payload) {
    state.authToSend = payload
  },
  SET_SSO_REFRESH_TIME(state, payload) {
    state.time_to_refresh_token_sso = payload
    localStorage.setItem('time_to_refresh', payload)
  },
  SET_CHATBOT_SUBSCRIPTION(state, payload) {
    state.chatbot_subscription = payload
  },
  SET_CHATBOT_PREFERENCES(state, payload) {
    state.chatbot_preferences = payload
  },
  UPDATE_NEW_USER_MANAGEMENT(state, payload) {
    state.userManagement = payload
  },
  SET_AGENT_CAN_SEND_BROADCAST(state, payload) {
    state.agent_can_send_broadcast = payload
  },

  UPDATE_PREFERENCES_BASED_ON_INBOX_PACKAGE(state, payload) {
    const customizedFeatures = {
      bottommenu: {},
      childsubmenu: {},
      homeUrl: {},
      menu: {},
      submenu: {},
      submenutab: {},
    }

    const menu = [
      'whatsapp',
      'contacts',
      'reports',
      'finances',
      'integrations',
      'settings',
      'custom_solutions',
      'subscriptions',
    ]
    const submenu = [
      'broadcast',
      'templates',
      'campaign_reports',
      'export',
      'package_usage',
      'whatsapp',
      'accounts_management',
      'agents',
      'contact',
      'security',
      'token',
      'subscriptions',
      'topup',
      'email',
    ]
    const childsubmenu = [
      'summary',
      'activity',
      'reports/export/campaign',
      'omnichannel',
      'campaign',
    ]
    const submenutab = ['broadcast', 'users']

    menu.forEach((slug) => {
      if (state.feature.menu[slug]) {
        state.feature.menu[slug].redirect = ''
        customizedFeatures.menu[slug] = state.feature.menu[slug]
      }
    })

    submenu.forEach((slug) => {
      if (state.feature.submenu[slug]) {
        customizedFeatures.submenu[slug] = state.feature.submenu[slug]
        if (
          customizedFeatures.menu[state.feature.submenu[slug].parent] &&
          !customizedFeatures.menu[state.feature.submenu[slug].parent].redirect
        ) {
          customizedFeatures.menu[state.feature.submenu[slug].parent].redirect =
            state.feature.submenu[slug].slug
        }
      }
    })

    childsubmenu.forEach((slug) => {
      if (state.feature.childsubmenu[slug]) {
        customizedFeatures.childsubmenu[slug] = state.feature.childsubmenu[slug]
      }
    })

    submenutab.forEach((slug) => {
      if (state.feature.submenutab[slug]) {
        customizedFeatures.submenutab[slug] = state.feature.submenutab[slug]
      }
    })

    const isUserCanSendBroadcast = payload.agent_can_send_broadcast
    const userRole = this.$auth.user.role

    // Determine home URL based on role and campaign access
    let homeUrl = 'campaign' // default

    if (userRole === 'owner') {
      // Owners: if they don't have campaign access (handled in organization settings),
      // they should redirect to inbox instead of campaign, but this will be overridden there
      homeUrl = 'campaign' // Default, will be overridden in organization settings if needed
    } else if (userRole === 'member') {
      // Members follow the same logic as agents for home URL
      homeUrl = isUserCanSendBroadcast ? 'campaign' : 'restricted'
    } else if (userRole === 'agent') {
      // Agents use the agent_can_send_broadcast setting
      homeUrl = isUserCanSendBroadcast ? 'campaign' : 'restricted'
    }
    // Other roles (admin, supervisor, super_admin) default to 'campaign'

    customizedFeatures.homeUrl.url = homeUrl
    customizedFeatures.bottommenu = state.feature.bottommenu

    state.feature = customizedFeatures
  },
}
